// CRM 2.0 bell (M1-F8, design §8.2 / §8.3): shared by the header bell block and the See all page.
import { useCallback, useEffect, useRef, useState } from "react";
import { getCrm2UnreadCount } from "../../../Services/Crm2Notifications";
import { canOpenCrm2 } from "../ui/access";

export const CRM2_NOTIFICATIONS_PATH = "/home/Crm2Notifications";
export const NO_ROWS_TEXT = "No CRM 2.0 notifications in the last 30 days.";
export const LOAD_ERROR_TEXT = "Couldn't load CRM 2.0 notifications.";

const COUNT_EVERY_MS = 60 * 1000;
const CHANGED = "crm2-notifications-changed";

// A row opens View CRM Details only for users who can open CRM 2.0 and only when it has a
// booking (the health check has none). Otherwise a click marks it read and shows the full text.
export const opensBooking = (row, user) => !!row?.allotmentPaymentId && canOpenCrm2(user);

// "just now", "5 min ago", "3 hours ago", "yesterday", "4 days ago"
export function timeAgo(ms, now = Date.now()) {
  const at = Number(ms);
  if (!at) return "";
  const min = Math.floor(Math.max(0, now - at) / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min} min ago`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? "yesterday" : `${days} days ago`;
}

export const fullTime = (ms) =>
  Number(ms) ? new Date(Number(ms)).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

// Tell the header badge that rows were read somewhere else (the See all page).
export function announceCrm2NotificationsChanged() {
  window.dispatchEvent(new Event(CHANGED));
}

// The bell badge: own unread CRM 2.0 rows, asked again every 60 seconds and whenever the
// See all page reads rows. Errors stay quiet (console only): the badge keeps its last count.
export function useCrm2UnreadCount() {
  const [count, setCount] = useState(0);
  const alive = useRef(true);

  const refresh = useCallback(() => {
    getCrm2UnreadCount()
      .then((d) => {
        if (alive.current) setCount(Number(d?.count) || 0);
      })
      .catch((err) => console.warn("[crm2][bell] unread count failed", { status: err?.response?.status, error: err?.message }));
  }, []);

  useEffect(() => {
    alive.current = true;
    refresh();
    const timer = setInterval(refresh, COUNT_EVERY_MS);
    window.addEventListener(CHANGED, refresh);
    return () => {
      alive.current = false;
      clearInterval(timer);
      window.removeEventListener(CHANGED, refresh);
    };
  }, [refresh]);

  return { count, setCount, refresh };
}
